<template>
  <div class="contain">
    <div class="box">
      <el-form ref="form" :model="form1" class="form">
        <el-form-item>
          <el-input placeholder="请输入池子名" v-model="form1.name"></el-input>
        </el-form-item>
        <el-form-item class="item">
          <el-select @focus="loadAgent" clearable filterable allow-create default-first-option v-model="form1.agentId" placeholder="代理商">
            <el-option label="请选择" value="-1"></el-option>
            <el-option v-for="item in agentList" :label="item.agentName" :value="item.agentId" :key="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" plain size="small" icon="el-icon-search" @click="onSubmit(1)" style="margin-left:10px">搜索</el-button>
          <el-button type="primary" plain size="small" icon="el-icon-upload2" @click="uploading" style="margin-left:10px">导卡入池</el-button>
          <el-button type="primary" plain size="small" icon="el-icon-upload2" @click="deleteing" style="margin-left:10px">导卡销池</el-button>
          <el-button v-if="roleId==='777'" type="primary" plain size="small" icon="el-icon-plus" @click="addFunction" style="margin-left:10px">新增</el-button>
        </el-form-item>
      </el-form>
    </div>

    <el-table ref="multipleTable" :data="tableData" :row-style="{height:'40px',textAlign:'center'}"
              :cell-style="{height:'5px,0',textAlign:'center'}"
              :header-cell-style="{background:'#f8f8f9',color:'#333',textAlign:'center'}"
               border style="width: 100%;height: 70vh">
      <el-table-column type="selection" width="55">
      </el-table-column>
      <el-table-column prop="name" label="流量池名称" width="180">
        <template #default="scope">
          <el-tooltip :content="scope.row.name" raw-content placement="top-start" v-if="scope.row.name">
            <span v-if="scope.row.name && scope.row.name.length <= 10">
              {{scope.row.name}}
            </span>
            <span v-if="scope.row.name&& scope.row.name.length > 10">
              {{scope.row.name.substr(0, 10) + "..."}}
            </span>
          </el-tooltip>
          <span v-else-if="scope.row.name== null"> 无 </span>
        </template>
      </el-table-column>
      <el-table-column prop="nameCust" label="流量池前端名称" width="180" v-if="roleId==='777'">
        <template #default="scope">
          <el-tooltip :content="scope.row.nameCust" raw-content placement="top-start" v-if="scope.row.nameCust">
            <span v-if="scope.row.nameCust && scope.row.nameCust.length <= 10">
              {{scope.row.nameCust}}
            </span>
            <span v-if="scope.row.nameCust&& scope.row.nameCust.length > 10">
              {{scope.row.nameCust.substr(0, 10) + "..."}}
            </span>
          </el-tooltip>
          <span v-else-if="scope.row.nameCust== null"> 无 </span>
        </template>
      </el-table-column>
      <el-table-column prop="cards" label="池子卡数量" width="120"/>
      <el-table-column prop="cardType" label="资源" width="120">
      </el-table-column>

      <el-table-column prop="wrongSpecification" label="池子规格(单位G)" width="180">
      </el-table-column>
      <el-table-column prop="so" label="卡池so系数" width="120">
      </el-table-column>
      <el-table-column prop="agentId" label="代理商ID" width="120" v-if="roleId==='777'">
      </el-table-column>

      <el-table-column prop="status" label="池子状态" width="120">
        <template slot-scope="scope">
          <div v-if="scope.row.status===0">正常</div>
          <div v-if="scope.row.status===1">销池</div>
          <div v-if="scope.row.status===2">卡池停机</div>
        </template>
      </el-table-column>
      <el-table-column  prop="poolUsed" label="池子用量(单位MB)" width="180">
      </el-table-column>
      <el-table-column  prop="poolTotal" label="池子总量(单位MB)" width="180">
      </el-table-column>
      <el-table-column prop="price" label="池子金额" width="120">
      </el-table-column>
      <el-table-column  prop="unitPrice" label="卡费/G" width="120" v-if="roleId==='777'">
      </el-table-column>
      <el-table-column  prop="version" label="池子编号" width="150">
      </el-table-column>
      <el-table-column  prop="stopOrCost" label="超量处理方式" width="150">
        <template slot-scope="scope">
          <div v-if="scope.row.stopOrCost===1">超量停机</div>
          <div v-if="scope.row.stopOrCost===2">超量扣费</div>
        </template>
      </el-table-column>
      <el-table-column  prop="createTime" label="创建时间" width="180">
        <template slot-scope="scope">
          <div>{{scope.row.createTime}}</div>
        </template>
      </el-table-column>
      <el-table-column
              label="操作" min-width="200">
        <template slot-scope="scope">
          <el-button v-if="roleId==='777'" @click="manRecharge(scope.row,'rech')" type="text" size="small" class="but">池子充值</el-button>
          <el-button v-if="roleId==='777'" @click="manRecharge(scope.row,'dedu')" type="text" size="small" class="but">池子扣费</el-button>
          <el-button @click="manAddFlow(scope.row)" type="text" size="small" class="but">池子加包</el-button>
        </template>
      </el-table-column>
      <!-- <template slot-scope="scope">
          <el-button @click="handleClick(scope.row)" type="text" size="small" class="but">编辑</el-button>
          <el-button type="text" size="small" class="but" @click="removeClick(scope.row)">删除</el-button>
        </template>
        <el-table-column
        <el-table-column width="220" prop="poolUsed" label="池子用量">
        </el-table-column>
        <el-table-column width="220" prop="poolTotal" label="池子总量">
        </el-table-column>
        <el-table-column width="220" prop="price" label="池子金额">
        </el-table-column>
        <el-table-column width="220" prop="unitPrice" label="卡费/G">
        </el-table-column>
        <el-table-column width="180" prop="version" label="池子编号">
        </el-table-column>
        <el-table-column width="180" prop="createTime" label="创建时间">
        </el-table-column>
        <el-table-column width="180" prop="updateTime" label="更新时间">
        </el-table-column>
          -->
    </el-table>
    <pagination class="text-center" ref="pagination" v-bind:list="onSubmit" v-bind:itemCount="8"></pagination>

    <!-- 新增弹窗 -->
    <el-dialog class="class_dialog_hospital" title="新增流量池" :visible.sync="dialogFormVisible" width="40%" :close-on-click-modal="false">
      <el-form :model="form" ref="form" :rules="rules">
        <el-form-item label="池子名称" class="XX" :label-width="formLabelWidth" prop="name">
          <el-input style="width:70%" placeholder="请输入池子名称" v-model="form.name" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="池子前端显示名称" class="XX" :label-width="formLabelWidth" prop="nameCust">
          <el-input style="width: 70%" placeholder="请输入池子前端名称" v-model="form.nameCust" autocomplete="off"/>
        </el-form-item>
        <el-form-item label="类型" :label-width="formLabelWidth" prop="cardType">
          <el-input style="width:70%" v-model="form.cardType" placeholder="请输入池子类型(例如：**_dx)" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="池子规格(单位/G)" :label-width="formLabelWidth" prop="sizeSpecification">
          <el-input style="width:70%" v-model="form.sizeSpecification" autocomplete="off" placeholder="请输入池子规格/单卡规格"></el-input>
        </el-form-item>

        <el-form-item label="代理商ID" :label-width="formLabelWidth" prop="agentId">
          <el-select @focus="loadAgent" filterable allow-create default-first-option v-model="form.agentId" placeholder="请选择代理商" style="width:70%">
            <el-option label="代理商选择" value=""></el-option>
            <el-option v-for="item in agentList" :label="item.agentName" :value="item.agentId" :key="item.id"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="卡池so系数" :label-width="formLabelWidth" prop="so">
          <el-input style="width:70%" v-model="form.so" autocomplete="off" placeholder="请输入卡池so"></el-input>
        </el-form-item>
        <!-- <el-form-item label="池子总量" :label-width="formLabelWidth" prop="poolTotal">
                    <el-input style="width:50%" v-model="form.poolTotal" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="池子金额" :label-width="formLabelWidth" prop="price">
                    <el-input style="width:50%" v-model="form.price" autocomplete="off"></el-input>
                </el-form-item>-->
        <el-form-item label="卡费(/张)" :label-width="formLabelWidth" prop="unitPrice">
          <el-input style="width:70%" v-model="form.unitPrice" autocomplete="off" placeholder="请输入卡费/单卡卡费"></el-input>
        </el-form-item>
        <el-form-item label="超量处理方式" :label-width="formLabelWidth" prop="stopOrCost">
          <el-radio-group style="width:70%" v-model="form.stopOrCost" autocomplete="off">
            <el-radio :label="1" >超量停机</el-radio>
            <el-radio :label="2" >超量扣费</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="Hnew('form')">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 充值 -->
    <el-dialog class="class_dialog_hospital" :visible.sync="RechargeBle" width="40%" :close-on-click-modal="false">
      <template slot="title"> <span>池子{{word}}操作</span> </template>
      <el-form>
        <el-form-item label="卡池余额：">
          <span><strong style="color: red">{{form.price+' 元'}}</strong></span>
        </el-form-item>
        <el-form-item>
          <el-input type="number" placeholder="请输入正数金额"  v-model="rechargePrice"/>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="RechargeBle=false">取 消</el-button>
        <el-button type="primary" @click.stop="savePrice(form.version,rechargePrice,word)">确 定</el-button>
      </div>
    </el-dialog>
    <!-- jiaBao -->
    <el-dialog class="class_dialog_hospital"  title="手动扩池" :visible.sync="FlowModel" width="40%" :close-on-click-modal="false">

      <br/>
      <el-form>
        <el-form-item label="卡池余额：">
          <span style="padding-bottom: 3%"><strong style="color: red">{{form.price+' 元'}}</strong></span>
        </el-form-item>
        <el-form-item label="扩池套餐：">
          <el-select @click="packetList" v-model="packetId" placeholder="请选择池子包规格" style="width:70%">
            <el-option v-for="item in flowList" :label="item.packetName" :value="item.packetId" :key="item.id"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="叠加次数：">
          <el-input type="number" placeholder="请输入选择包体加包次数" v-model="number" style="width: 70%"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="FlowModel=false">取 消</el-button>
        <el-button type="primary" @click.stop="saveFlow(form.version,packetId,number)">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 编辑弹窗 -->
    <el-dialog title="编辑" :visible.sync="dialogVisible" width="40%" :close-on-click-modal="false">
      <el-form :model="form">
        <el-form-item label="卡号" class="XX" :label-width="formLabelWidth">
          <el-input style="width:70%" v-model="form.name" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="真实号码" :label-width="formLabelWidth">
          <el-input style="width:70%" v-model="form.name" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="自定义号码" class="XX" :label-width="formLabelWidth">
          <el-input style="width:70%" v-model="form.name" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="池子规格(单位G)" class="XX" :label-width="formLabelWidth">
          <el-input style="width:70%" v-model="form.name" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="代理商ID" :label-width="formLabelWidth">
          <el-select v-model="form.agent" placeholder="请选择代理商">
            <el-option label="代理商一" value="1"></el-option>
            <el-option label="代理商二" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="卡池so系数" :label-width="formLabelWidth">
          <el-input style="width:70%" v-model="form.name" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="卡状态" :label-width="formLabelWidth">
          <el-select v-model="form.agent" placeholder="请选择卡状态">
            <el-option label="状态一" value="1"></el-option>
            <el-option label="状态二" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="使用量" :label-width="formLabelWidth">
          <el-input style="width:70%" v-model="form.name" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="池子编号" :label-width="formLabelWidth">
          <el-input style="width:70%" v-model="form.name" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="创建时间" :label-width="formLabelWidth">
          <el-input style="width:70%" v-model="form.name" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="更新时间" :label-width="formLabelWidth">
          <el-input style="width:70%" v-model="form.name" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 编辑弹窗结束 -->

    <!-- 点击上传弹窗 -->
    <el-dialog width="30%" title="导卡入池" :visible.sync="dialogUploading" :close-on-click-modal="false" class="Hup">
      <span><a :href="importUrl">下载模板</a></span>
      <br />
      <p />
      <span>温馨提示：iccid，短号，自定义卡号，cardType（资源类型），sizeSpecification（单卡扩池规格单位：G,系统填写so之后的值）
agentId（代理商Id），version（卡池编号）请如实填写！请如实填写！</span>
      <p />
      <el-upload :disabled="false" ref="upload" class="upload-demo" drag :action="uploadUrl"
                 multiple :limit="limitNum" accept=".csv,.xls,.xlsx" :auto-upload="false"
                 :on-change="this.$upload.onChange" :before-upload="this.$upload.beforeUpload"
                 :on-exceed="this.$upload.onExcced" :headers="headers"
                 :on-success="handleSuccess" :on-error="handleError" :file-list="fileList">
        <i class="el-icon-upload"></i>
        <div class="el-upload__tip">请上传csv或excel文件</div>
        <div class="el-upload__text">
          将文件拖到此处，或
          <em>点击上传</em>
        </div>
      </el-upload>
      <div slot="footer" class="dialog-footer">
        <el-button type="info" size="small"  @click="dialogUploading = false">取 消</el-button>
        <el-button type="primary" size="small" plain @click="Huploading">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 点击上传弹窗结束 -->

    <!--点击长传销卡-->
    <el-dialog width="30%" title="导卡销池" :visible.sync="dialogDeleteing" :close-on-click-modal="false" class="Hup">
      <span><a :href="importUrl1">下载模板</a></span>
      <p />
      <el-upload :disabled="false" ref="upload" class="upload-demo" drag :action="deleteUrl"
                 multiple :limit="limitNum" accept=".csv,.xls,.xlsx" :auto-upload="false"
                 :on-change="this.$upload.onChange" :before-upload="this.$upload.beforeUpload"
                 :on-exceed="this.$upload.onExcced" :headers="headers"
                 :on-success="handleSuccess" :on-error="handleError" :file-list="fileList">
        <i class="el-icon-upload"></i>
        <div class="el-upload__tip">请上传csv或excel文件</div>
        <div class="el-upload__text">
          将文件拖到此处，或
          <em>点击上传</em>
        </div>
      </el-upload>
      <div slot="footer" class="dialog-footer">
        <el-button type="info" size="small"  @click="dialogDeleteing = false">取 消</el-button>
        <el-button type="primary" size="small" plain @click="Huploading">确 定</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import Pagination from '../../../components/pagination.vue'
export default {
  name: 'addPool',
  components: {
    Pagination,
  },

  mounted() {

    this.headers={
      token: sessionStorage.getItem("sys-token"),
      userId: sessionStorage.getItem("loginUser")!==null?JSON.parse(sessionStorage.getItem("loginUser")).id:''
    }
    this.roleId =this.$loginUser.roleId
  },
  data() {
    return {
      roleId: '',
      packetId:"",
      rechargePrice:0.00,
      name: sessionStorage.getItem('name'),
      sessionAgentId: sessionStorage.getItem('agentId'),
      // importUrl: 'http://' + location.host + '/download/excel/importcard.xlsx',
      importUrl:'http://'+location.host+'/download/excel/importcardUp.xlsx',
      importUrl1:'http://'+location.host+'/download/excel/delcardpool.xlsx',
      agentList: [],
      //点击上传
      uploadUrl: process.env.VUE_APP_SERVER+'/manager/pool-flow/importCardPool',
      deleteUrl: process.env.VUE_APP_SERVER+'/manager/pool-flow/deleteCardPool',
      headers:{},
      limitNum: 0,
      fileList: [],
      flowList:[],
      RechargeBle:false,
      dialogUploading: false,
      dialogDeleteing: false,
      FlowModel:false,
      rules: {
        name: [
          { required: true, message: '请输入池子名称', trigger: 'blur' },
          { min: 3, max: 15, message: '长度在 3 到 15 个字符', trigger: 'blur' }
        ],
        version: [{ required: true, message: '请输入池子编号', trigger: 'blur' }],
        cardType: [{ required: true, message: '请输入池子类型', trigger: 'blur' }],
        sizeSpecification: [{ required: true, message: '请选择规格', trigger: 'change' }],
        agentId: [{ required: true, message: '请输入代理商ID', trigger: 'blur' }],
        so: [{ required: true, message: '请输入卡池so系数', trigger: 'blur' }],
        status: [{ required: true, message: '请输入池子状态', trigger: 'blur' }],
        poolUsed: [{ required: true, message: '请输入池子用量', trigger: 'blur' }],
        /*  poolTotal: [
                        {required: true, message: '请输入池子总量', trigger: 'blur'},
                    ],
                    price: [
                        {required: true, message: '请输入池子金额', trigger: 'blur'},
                    ],*/
        unitPrice: [{ required: true, message: '请输入卡池/g', trigger: 'blur' }],
        stopOrCost: [{ required: true, message: '请选择超量处理方式', trigger: 'blur' }],
      },
      form1: {
        name: '',
        version: '',
        cardType: '',
        agentId: '',
        current:1,
        size:10
      },
      form: {
        name: '',
        version: '',
        cardType: '',
        sizeSpecification: '',
        agentId: '',
        so: null,
        poolTotal: '',
        price: '',
        unitPrice: '',
        poolUsed: '',
        status: '',
        nameCust:'',
        stopOrCost:0
      },
      word:'',
      dialogFormVisible: false,
      dialogVisible: false,
      formLabelWidth: '180px',
      tableData: [],
      maxHeight: '1500px',
      number:0,
      agentJs: require('../../../api/agent'),
      poolJs: require('../../../api/pool')
    }
  },
  methods: {
    packetList(){
      let that=this
      that.poolJs.packetList().then(response => {
        if(response.data.code==='0'){
          this.flowList = response.data.data
        }
      })
    },
    loadAgent(){
      this.agentJs.getSearchAgent(
              {}).then(res=>{
        res.data.data.map(item=>{
          let map={
            agentId: item.agentId,
            agentName: item.agentName
          }
          this.agentList.push(map)
        })

      })
    },

    // 文件上传成功时的钩子
    handleSuccess(res, file, fileList) {
      this.btnDisabled = false
      if (res.code === '0') {
        this.$alert(res.data)
        this.$refs.upload.clearFiles()
        this.diaVisImport = false
      } else {
        this.$alert(res.msg)
        this.$refs.upload.clearFiles()
      }
    },
    // 文件上传失败时的钩子
    handleError(err, file, fileList) {
      this.$notify.error({
        title: '错误',
        message: `文件上传失败`
      })
      this.$refs.upload.clearFiles()
    },
    uploadCardRoute() {
      this.btnDisabled = true
      this.$refs.upload.submit()
    },
    //点击导入确认
    Huploading() {
      this.dialogUploading = false
      this.$refs.upload.submit()
    },
    //点击上传
    uploading() {
      this.dialogUploading = true
    },
    //点击上传
    deleteing() {
      this.dialogDeleteing = true
    },

    onSubmit(page) {
      let _this = this
      _this.form1.current = page
      _this.form1.size = _this.$refs.pagination.size
      _this.poolJs.findPool(_this.form1).then(response => {
        _this.$refs.pagination.render(page, response.data.data.total)
        _this.tableData = response.data.data.rows
      })
    },
    removeClick() {
      this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.$message({
            type: 'success',
            message: '删除成功!'
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    handleClick(row) {
      this.dialogVisible = true
    },

    manRecharge(row,type) {
      if(type==='rech'){
        this.word = '充值'
      }if(type==='dedu'){
        this.word = '扣费'
      }
      this.form = row
      this.rechargePrice=''
      this.RechargeBle = true
    },

    savePrice(version,price){
      let _this = this
      let map={
        "price": price,
        "version": version,
        "name":_this.name,
        "word":_this.word
      }
      _this.poolJs.savePrice(map).then(res => {
        if (res.data.code === "0") {
          _this.$alert(res.data.data)
          _this.RechargeBle = false
          _this.onSubmit(1)
        } else {
          _this.$alert(res.data.msg)
          _this.RechargeBle = false
        }
      })
    },

    Hnew(form) {
      let that = this
      that.$refs[form].validate(valid => {
        if (valid) {
          that.dialogFormVisible = false
          that.poolJs.addPool( this.form).then(response => {
            if(response.data.code==='0'){
              that.$alert(response.data.data)
              that.onSubmit(1)
            }else{
              that.$alert(response.data.msg)
            }
          })
        }
      })
    },

    addFunction() {
      this.form = {}
      this.dialogFormVisible = true
    },

    manAddFlow(row) {
      this.form = row
      this.FlowModel = true

    },
    saveFlow(version,packetId,number){
      let _this = this
      if(number===0){
        _this.$alert("叠加包次数至少为1次")
        return false;
      }
      let map={
        "packetId": packetId,
        "version": version,
        "name":_this.name,
        "number":number,
      }
      _this.poolJs.saveFlow(map).then(res => {
        if (res.data.code === "0") {
          _this.$alert(res.data.data)
          _this.FlowModel = false
          _this.onSubmit(1)
        } else {
          _this.$alert(res.data.msg)
          _this.FlowModel = false
        }
      })
    },
  },



}
</script>

<style lang="less" scoped>

  /* 设置滚动条宽度和高度 */
  ::v-deep .el-table__body-wrapper::-webkit-scrollbar {
    width: 10px; /* 横向滚动条 */
    height: 10px; /* 纵向滚动条 必写 */
  }
  /* 设置滚动条样式 */
  ::v-deep .el-table__body-wrapper::-webkit-scrollbar-thumb {
    background-color: #dde;
    border-radius: 3px;
  }
  ::v-deep .el-table {
    height: 88%;
    .el-table__body-wrapper {
      height: calc(100% - 48px) !important; // 表格高度减去表头的高度
      overflow-y: auto;
    }
  }



  .contain {
  position: relative;
  padding: 20px;
  background: #fff;
  border-radius: 5px;
}
.box {
  width: 100%;
  height: 100%;
  border-radius: 10px;

  .form {
    display: flex;
  }

  .item {
    margin-left: 10px;
  }

  .XX {
    width: 20%;
  }

  .but {
    font-size: 14px;
    margin-left: 30px;
  }

  h1 {
    text-align: center;
    font-weight: 700;
    font-size: 30px;
  }
}
/deep/ .el-input__inner {
  height: 35px;
}

</style>
<style lang="less" scoped>
/deep/.el-table td,
.el-table th {
  padding: 0px;
}
</style>
<style lang="less">
.el-table td,
.el-table th {
  padding: 0px !important;
}
thead.has-gutter {
  height: 40px;
}
</style>
